import { Analytics as AnalyticsLibrary } from '@carvana/core-analytics';
import { getMyCarsReskinBucket, isMyCarsReskinFixed } from '@utils/myCarsReskinExperiment';
import { getOrCreateSessionId, rotateSessionId } from '@utils/session-id';
import { setDataDogUser } from '@utils/dataDogRum';
import { Analytics as AnalyticsConst } from '../constants';

export const Analytics = new AnalyticsLibrary({
  environment: (process.env.NODE_ENV as string) || 'development',
  project: AnalyticsConst.PROJECT_NAME,
  track: AnalyticsConst.TEAM_NAME,
  correlationId: getOrCreateSessionId(),
  isLocalInstance: process.env.LOCAL === 'true',
});

Analytics.setGlobalCustomAttributes({
  controlFixed: isMyCarsReskinFixed(),
  myCarsReskinBucket: getMyCarsReskinBucket(),
});

/**
 * Retires the signed-out user's correlation id and republishes the replacement to every consumer
 * that snapshotted the old one, so clickstream and RUM stay joinable to the backend logs.
 *
 * Must be called BEFORE the logout itself: logout callbacks can run synchronously and redirect,
 * and work queued after navigation starts is not guaranteed to run. The logout request is
 * unaffected either way - it goes out on core-auth's own client, which never carried the header.
 */
export const resetCorrelationId = (): void => {
  rotateSessionId();
  Analytics.correlationId = getOrCreateSessionId();
  setDataDogUser();
};
